<template>
  <fragment>
    <g
      id="Nose_type_01-01_A-3"
      v-if="data.value === 'type-3' && data.position === 't'"
    >
      <g>
        <path
          d="M158.3,179.54c.82,.4,.79,4.74,.02,7.89-1.14,4.66-3,7.83-1.97,9.97,1.19,2.46,6.1,3.65,6.48,4.47,.61,1.31-6.21,1.4-9.2,.07s-4.47-3.03-3.51-5.76,2.88-5.72,4.6-9.7c1.54-3.57,2.27-7.57,3.58-6.93Z"
          :fill="data.color"
        />
        <path
          d="M158.3,179.54c.82,.4,.79,4.74,.02,7.89-1.14,4.66-3,7.83-1.97,9.97,1.19,2.46,6.1,3.65,6.48,4.47,.61,1.31-6.21,1.4-9.2,.07s-4.47-3.03-3.51-5.76,2.88-5.72,4.6-9.7c1.54-3.57,2.27-7.57,3.58-6.93Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_01-02_A-3"
      v-if="data.value === 'type-2' && data.position === 't'"
    >
      <g>
        <path
          d="M158.3,168.95c.82,.58,.79,6.88,.02,11.47-1.14,6.78-3,11.38-1.97,14.49,1.19,3.58,6.1,5.31,6.48,6.49,.61,1.9-6.21,2.04-9.2,.1s-4.47-4.41-3.51-8.37,2.88-8.31,4.6-14.11c1.54-5.19,2.27-11,3.58-10.07Z"
          :fill="data.color"
        />
        <path
          d="M158.3,168.95c.82,.58,.79,6.88,.02,11.47-1.14,6.78-3,11.38-1.97,14.49,1.19,3.58,6.1,5.31,6.48,6.49,.61,1.9-6.21,2.04-9.2,.1s-4.47-4.41-3.51-8.37,2.88-8.31,4.6-14.11c1.54-5.19,2.27-11,3.58-10.07Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_01-03_A-3"
      v-if="data.value === 'type-1' && data.position === 't'"
    >
      <g>
        <path
          d="M159.64,160.95c1.21,.73-.41,8.78-1.54,14.55-1.68,8.52-6.12,15.12-4.59,19.03,1.76,4.5,12.26,5.74,12.82,7.22,.9,2.39-9.68,1.53-14.08-.92s-6.11-4.51-4.7-9.48,4.25-10.45,6.79-17.74c2.27-6.52,3.35-13.84,5.29-12.67Z"
          :fill="data.color"
        />
        <path
          d="M159.64,160.95c1.21,.73-.41,8.78-1.54,14.55-1.68,8.52-6.12,15.12-4.59,19.03,1.76,4.5,12.26,5.74,12.82,7.22,.9,2.39-9.68,1.53-14.08-.92s-6.11-4.51-4.7-9.48,4.25-10.45,6.79-17.74c2.27-6.52,3.35-13.84,5.29-12.67Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_02-01_A-3"
      v-if="data.value === 'type-6' && data.position === 't'"
    >
      <g>
        <path
          id="_-123"
          d="M160.67,185.5c-.37,3.3-.91,6.4-.93,9.2,0,1.68,.67,3.6,1.19,5.05,.15,.41-.2,.81-.56,.64-1.74-.82-4.63-3.47-3.83-6.05,.95-3.06,1.75-5.12,3.32-9.15,.19-.49,.86-.22,.8,.31Z"
          :fill="data.color"
        />
        <g opacity=".3">
          <path
            id="_-124"
            d="M160.67,185.5c-.37,3.3-.91,6.4-.93,9.2,0,1.68,.67,3.6,1.19,5.05,.15,.41-.2,.81-.56,.64-1.74-.82-4.63-3.47-3.83-6.05,.95-3.06,1.75-5.12,3.32-9.15,.19-.49,.86-.22,.8,.31Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_02-02_A-3"
      v-if="data.value === 'type-5' && data.position === 't'"
    >
      <g>
        <path
          id="_-125"
          d="M160.57,178.14c-.5,5.6-1.23,10.85-1.25,15.6,0,2.85,.9,6.11,1.6,8.57,.2,.69-.27,1.38-.75,1.09-2.34-1.39-6.24-5.88-5.16-10.27,1.28-5.19,2.36-8.69,4.47-15.52,.26-.83,1.17-.38,1.08,.53Z"
          :fill="data.color"
        />
        <g opacity=".3">
          <path
            id="_-126"
            d="M160.57,178.14c-.5,5.6-1.23,10.85-1.25,15.6,0,2.85,.9,6.11,1.6,8.57,.2,.69-.27,1.38-.75,1.09-2.34-1.39-6.24-5.88-5.16-10.27,1.28-5.19,2.36-8.69,4.47-15.52,.26-.83,1.17-.38,1.08,.53Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_02-03_A-3"
      v-if="data.value === 'type-4' && data.position === 't'"
    >
      <g>
        <path
          id="_-127"
          d="M162.03,169.34c-.6,7.98-1.46,15.47-1.48,22.25-.01,4.07,1.07,8.71,1.9,12.21,.24,.99-.32,1.97-.89,1.56-2.78-1.98-7.4-8.39-6.12-14.64,1.51-7.4,2.8-12.39,5.3-22.13,.3-1.18,1.38-.54,1.28,.76Z"
          :fill="data.color"
        />
        <g opacity=".3">
          <path
            id="_-128"
            d="M162.03,169.34c-.6,7.98-1.46,15.47-1.48,22.25-.01,4.07,1.07,8.71,1.9,12.21,.24,.99-.32,1.97-.89,1.56-2.78-1.98-7.4-8.39-6.12-14.64,1.51-7.4,2.8-12.39,5.3-22.13,.3-1.18,1.38-.54,1.28,.76Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_03-01_A-3"
      v-if="data.value === 'type-9' && data.position === 't'"
    >
      <g>
        <path
          d="M166.83,202.33c-1.66-.18-3.62-.44-5.5-.94-3.11-.91-5.99-2.1-6.01-4.62,.23-2.97,2.34-5.45,4.67-7.94,.11-.12,.12-.29,.03-.42-.09-.13-.26-.18-.42-.13-4.29,1.42-7.61,5.2-7.72,8.78-.08,2.72,1.69,4.93,4.99,6.23,1.7,.64,3.54,.96,5.42,.96,1.55,0,3.13-.22,4.68-.66,.31-.09,.51-.37,.48-.67-.03-.31-.28-.55-.61-.59Z"
          :fill="data.color"
        />
        <path
          d="M166.83,202.33c-1.66-.18-3.62-.44-5.5-.94-3.11-.91-5.99-2.1-6.01-4.62,.23-2.97,2.34-5.45,4.67-7.94,.11-.12,.12-.29,.03-.42-.09-.13-.26-.18-.42-.13-4.29,1.42-7.61,5.2-7.72,8.78-.08,2.72,1.69,4.93,4.99,6.23,1.7,.64,3.54,.96,5.42,.96,1.55,0,3.13-.22,4.68-.66,.31-.09,.51-.37,.48-.67-.03-.31-.28-.55-.61-.59Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_03-02_A-3"
      v-if="data.value === 'type-8' && data.position === 't'"
    >
      <g>
        <path
          d="M169.98,203.43c-2.3-.27-5.01-.64-7.61-1.37-4.3-1.34-8.28-3.09-8.3-6.78,.32-4.36,3.23-8,6.46-11.66,.15-.17,.17-.42,.04-.61-.13-.19-.37-.27-.58-.19-5.94,2.09-10.53,7.63-10.68,12.89-.11,3.99,2.33,7.24,6.89,9.14,2.34,.94,4.89,1.41,7.49,1.41,2.15,0,4.33-.32,6.47-.97,.43-.13,.7-.54,.66-.99-.04-.46-.39-.81-.84-.87Z"
          :fill="data.color"
        />
        <path
          d="M169.98,203.43c-2.3-.27-5.01-.64-7.61-1.37-4.3-1.34-8.28-3.09-8.3-6.78,.32-4.36,3.23-8,6.46-11.66,.15-.17,.17-.42,.04-.61-.13-.19-.37-.27-.58-.19-5.94,2.09-10.53,7.63-10.68,12.89-.11,3.99,2.33,7.24,6.89,9.14,2.34,.94,4.89,1.41,7.49,1.41,2.15,0,4.33-.32,6.47-.97,.43-.13,.7-.54,.66-.99-.04-.46-.39-.81-.84-.87Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_03-03_A-3"
      v-if="data.value === 'type-7' && data.position === 't'"
    >
      <g>
        <path
          d="M172.1,203.41c-2.78-.33-6.91-.69-10.1-1.39-5.49-1.21-10.12-4.06-10.14-8.57,.38-5.33,4.94-9.79,8.83-14.26,.18-.21,.2-.52,.05-.75-.15-.23-.44-.33-.7-.23-7.16,2.55-12.7,9.33-12.88,15.76-.14,4.88,2.81,8.85,8.31,11.18,2.83,1.15,5.9,1.73,9.04,1.73,2.59,0,5.23-.39,7.8-1.19,.52-.16,.85-.66,.8-1.21-.05-.56-.47-1-1.01-1.06Z"
          :fill="data.color"
        />
        <path
          d="M172.1,203.41c-2.78-.33-6.91-.69-10.1-1.39-5.49-1.21-10.12-4.06-10.14-8.57,.38-5.33,4.94-9.79,8.83-14.26,.18-.21,.2-.52,.05-.75-.15-.23-.44-.33-.7-.23-7.16,2.55-12.7,9.33-12.88,15.76-.14,4.88,2.81,8.85,8.31,11.18,2.83,1.15,5.9,1.73,9.04,1.73,2.59,0,5.23-.39,7.8-1.19,.52-.16,.85-.66,.8-1.21-.05-.56-.47-1-1.01-1.06Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_04-01_A-3"
      v-if="data.value === 'type-12' && data.position === 't'"
    >
      <g>
        <path
          d="M152.17,186.67c-.23,0-2.37,.05-3.54,.65-2.31,1.2-3.52,4.6-2.37,7.09,1.94,4.2,6.84,5.57,10.36,6.23,.02,0,.04,0,.07,0,.14,0,.27-.08,.32-.21,.07-.15,.02-.33-.11-.43-.5-.38-1.13-.8-1.8-1.25-2.77-1.85-6.56-4.37-5.61-7.16,.4-1.26,1.15-1.51,2.79-1.62l.56-.04c.75-.06,1.52-.11,2.28-.24,.71-.04,1.27-.55,1.34-1.22,.3-2.96,1.6-9.13,1.68-12.29,0-.27-.19-.5-.46-.55-.14-.03-.28,0-.39,.08,0,0-.14,.09-.22,.29-.11,.29-1.9,6.11-2.97,10.05-.11,.39-.47,.66-.88,.63-.31-.02-.66-.03-1.04-.02Z"
          :fill="data.color"
        />
        <path
          d="M152.17,186.67c-.23,0-2.37,.05-3.54,.65-2.31,1.2-3.52,4.6-2.37,7.09,1.94,4.2,6.84,5.57,10.36,6.23,.02,0,.04,0,.07,0,.14,0,.27-.08,.32-.21,.07-.15,.02-.33-.11-.43-.5-.38-1.13-.8-1.8-1.25-2.77-1.85-6.56-4.37-5.61-7.16,.4-1.26,1.15-1.51,2.79-1.62l.56-.04c.75-.06,1.52-.11,2.28-.24,.71-.04,1.27-.55,1.34-1.22,.3-2.96,1.6-9.13,1.68-12.29,0-.27-.19-.5-.46-.55-.14-.03-.28,0-.39,.08,0,0-.14,.09-.22,.29-.11,.29-1.9,6.11-2.97,10.05-.11,.39-.47,.66-.88,.63-.31-.02-.66-.03-1.04-.02Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_04-02_A-3"
      v-if="data.value === 'type-11' && data.position === 't'"
    >
      <g>
        <path
          d="M152.45,180.94c-.33,0-3.35,.06-4.99,.92-3.26,1.69-4.97,6.48-3.34,10,2.74,5.92,9.65,7.85,14.61,8.79,.03,0,.06,0,.09,0,.19,0,.38-.11,.46-.3,.09-.21,.03-.46-.15-.6-.71-.54-1.6-1.13-2.54-1.76-3.9-2.6-9.25-6.17-7.91-10.09,.57-1.78,1.62-2.13,3.93-2.29l.79-.06c1.05-.08,2.14-.16,3.21-.33,.99-.06,1.79-.78,1.88-1.72,.43-4.17,.84-8.64,.95-13.09,0-.38-.26-.71-.64-.78-.2-.04-.4,0-.55,.11,0,0-.2,.13-.31,.41-.16,.41-1.27,4.39-2.77,9.94-.15,.56-.67,.93-1.24,.89-.43-.03-.93-.05-1.47-.03Z"
          :fill="data.color"
        />
        <path
          d="M152.45,180.94c-.33,0-3.35,.06-4.99,.92-3.26,1.69-4.97,6.48-3.34,10,2.74,5.92,9.65,7.85,14.61,8.79,.03,0,.06,0,.09,0,.19,0,.38-.11,.46-.3,.09-.21,.03-.46-.15-.6-.71-.54-1.6-1.13-2.54-1.76-3.9-2.6-9.25-6.17-7.91-10.09,.57-1.78,1.62-2.13,3.93-2.29l.79-.06c1.05-.08,2.14-.16,3.21-.33,.99-.06,1.79-.78,1.88-1.72,.43-4.17,.84-8.64,.95-13.09,0-.38-.26-.71-.64-.78-.2-.04-.4,0-.55,.11,0,0-.2,.13-.31,.41-.16,.41-1.27,4.39-2.77,9.94-.15,.56-.67,.93-1.24,.89-.43-.03-.93-.05-1.47-.03Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_04-03_A-3"
      v-if="data.value === 'type-10' && data.position === 't'"
    >
      <g>
        <path
          d="M153.76,178.47c-.41,0-4.12,.08-6.15,1.14-4.02,2.1-6.12,8.05-4.12,12.41,3.37,7.35,11.88,9.74,17.99,10.91,.04,0,.08,.01,.11,.01,.24,0,.46-.14,.56-.37,.12-.26,.04-.57-.19-.75-.87-.67-1.97-1.41-3.13-2.19-4.81-3.23-11.39-7.65-9.75-12.52,.7-2.2,2-2.64,4.85-2.84l.98-.08c1.3-.1,2.64-.2,3.96-.41,1.23-.07,2.2-.97,2.32-2.14,.53-5.17,1.04-11.72,1.17-17.25,.01-.48-.32-.88-.79-.96-.25-.04-.49,0-.68,.13,0,0-.25,.16-.38,.51-.2,.51-1.56,6.45-3.41,13.33-.19,.69-.82,1.16-1.53,1.11-.53-.04-1.14-.06-1.81-.04Z"
          :fill="data.color"
        />
        <path
          d="M153.76,178.47c-.41,0-4.12,.08-6.15,1.14-4.02,2.1-6.12,8.05-4.12,12.41,3.37,7.35,11.88,9.74,17.99,10.91,.04,0,.08,.01,.11,.01,.24,0,.46-.14,.56-.37,.12-.26,.04-.57-.19-.75-.87-.67-1.97-1.41-3.13-2.19-4.81-3.23-11.39-7.65-9.75-12.52,.7-2.2,2-2.64,4.85-2.84l.98-.08c1.3-.1,2.64-.2,3.96-.41,1.23-.07,2.2-.97,2.32-2.14,.53-5.17,1.04-11.72,1.17-17.25,.01-.48-.32-.88-.79-.96-.25-.04-.49,0-.68,.13,0,0-.25,.16-.38,.51-.2,.51-1.56,6.45-3.41,13.33-.19,.69-.82,1.16-1.53,1.11-.53-.04-1.14-.06-1.81-.04Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_05-01_A-3"
      v-if="data.value === 'type-15' && data.position === 't'"
    >
      <g>
        <path
          d="M151.44,188.66c-.19,1.03-.24,1.89-.22,3.06,.03,1.4,1.06,2.08,2.11,2.67,1.12,.62,2.25,1.24,3.38,1.83,2.24,1.2,4.39,2.18,6.93,1.51,.1-.03,.19,.12,.11,.19-3.53,3.12-8.84,.94-12.15-1.29-1.63-1.1-3.28-2.63-2.49-4.86,.26-.74,.5-1.09,.95-1.77,.33-.5,.8-.96,1.2-1.43,.07-.08,.21-.02,.19,.09h0Z"
          :fill="data.color"
        />
        <g opacity=".3">
          <path
            d="M151.44,188.66c-.19,1.03-.24,1.89-.22,3.06,.03,1.4,1.06,2.08,2.11,2.67,1.12,.62,2.25,1.24,3.38,1.83,2.24,1.2,4.39,2.18,6.93,1.51,.1-.03,.19,.12,.11,.19-3.53,3.12-8.84,.94-12.15-1.29-1.63-1.1-3.28-2.63-2.49-4.86,.26-.74,.5-1.09,.95-1.77,.33-.5,.8-.96,1.2-1.43,.07-.08,.21-.02,.19,.09h0Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_05-02_A-3"
      v-if="data.value === 'type-14' && data.position === 't'"
    >
      <g>
        <path
          d="M150.29,186.8c-.24,1.32-.81,2.98-.75,4.23,.1,1.92,1.37,2.51,2.73,3.28,1.44,.8,2.9,1.6,4.36,2.36,2.88,1.55,6.1,2.67,9.36,1.82,.13-.04,.25,.15,.14,.24-4.54,4.02-11.02,.91-15.29-1.96-2.09-1.41-4.39-3.45-3.21-6.25,.32-.77,.75-1.45,1.04-1.91,.4-.67,.85-1.31,1.37-1.91,.09-.11,.28-.02,.25,.12h0Z"
          :fill="data.color"
        />
        <path
          d="M150.29,186.8c-.24,1.32-.81,2.98-.75,4.23,.1,1.92,1.37,2.51,2.73,3.28,1.44,.8,2.9,1.6,4.36,2.36,2.88,1.55,6.1,2.67,9.36,1.82,.13-.04,.25,.15,.14,.24-4.54,4.02-11.02,.91-15.29-1.96-2.09-1.41-4.39-3.45-3.21-6.25,.32-.77,.75-1.45,1.04-1.91,.4-.67,.85-1.31,1.37-1.91,.09-.11,.28-.02,.25,.12h0Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_05-03_A-3"
      v-if="data.value === 'type-13' && data.position === 't'"
    >
      <g>
        <path
          d="M147.2,184.28c-.27,1.89-.63,3.97-.67,5.74-.06,2.78,1.93,3.79,3.9,4.8,2.09,1.06,4.2,2.11,6.31,3.11,4.17,2.04,8.81,3.46,13.39,2.06,.19-.07,.36,.2,.21,.34-6.22,5.95-15.59,1.9-21.81-1.94-3.01-1.87-6.17-4.76-5.01-8.29,.03-.1,.29-.81,.34-.91,.33-.74,.79-1.64,1.15-2.26,.53-.97,1.13-1.9,1.83-2.79,.12-.16,.39-.05,.36,.15h0Z"
          :fill="data.color"
        />
        <path
          d="M147.2,184.28c-.27,1.89-.63,3.97-.67,5.74-.06,2.78,1.93,3.79,3.9,4.8,2.09,1.06,4.2,2.11,6.31,3.11,4.17,2.04,8.81,3.46,13.39,2.06,.19-.07,.36,.2,.21,.34-6.22,5.95-15.59,1.9-21.81-1.94-3.01-1.87-6.17-4.76-5.01-8.29,.03-.1,.29-.81,.34-.91,.33-.74,.79-1.64,1.15-2.26,.53-.97,1.13-1.9,1.83-2.79,.12-.16,.39-.05,.36,.15h0Z"
          :fill="data.color"
          opacity=".3"
        />
      </g>
    </g>
    <g
      id="Nose_type_06-01_A-3"
      v-if="data.value === 'type-18' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="156.64" cy="196.42" r="1.96" :fill="data.color" />
          <circle cx="163.43" cy="196.42" r="1.96" :fill="data.color" />
        </g>
        <g opacity=".3">
          <circle cx="156.64" cy="196.42" r="1.96" :fill="data.color" />
          <circle cx="163.43" cy="196.42" r="1.96" :fill="data.color" />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_06-02_A-3"
      v-if="data.value === 'type-17' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="155.4" cy="196.35" r="2.65" :fill="data.color" />
          <circle cx="164.6" cy="196.35" r="2.65" :fill="data.color" />
        </g>
        <g opacity=".3">
          <circle cx="155.4" cy="196.35" r="2.65" :fill="data.color" />
          <circle cx="164.6" cy="196.35" r="2.65" :fill="data.color" />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_06-03_A-3"
      v-if="data.value === 'type-16' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="153.27" cy="196.27" r="3.88" :fill="data.color" />
          <circle cx="166.73" cy="196.27" r="3.88" :fill="data.color" />
        </g>
        <g opacity=".3">
          <circle cx="153.27" cy="196.27" r="3.88" :fill="data.color" />
          <circle cx="166.73" cy="196.27" r="3.88" :fill="data.color" />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_07-01_A-3"
      v-if="data.value === 'type-21' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="156.64" cy="196.42" r="1.96" :fill="data.color" />
          <circle cx="163.43" cy="196.42" r="1.96" :fill="data.color" />
          <path
            d="M170.28,198.37c-.55,0-1-.45-1-1,0-4.36-4.41-8.32-9.25-8.32s-9.25,3.97-9.25,8.32c0,.55-.45,1-1,1s-1-.45-1-1c0-5.5,5.26-10.32,11.25-10.32s11.25,4.82,11.25,10.32c0,.55-.45,1-1,1Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <circle cx="156.64" cy="196.42" r="1.96" :fill="data.color" />
          <circle cx="163.43" cy="196.42" r="1.96" :fill="data.color" />
          <path
            d="M170.28,198.37c-.55,0-1-.45-1-1,0-4.36-4.41-8.32-9.25-8.32s-9.25,3.97-9.25,8.32c0,.55-.45,1-1,1s-1-.45-1-1c0-5.5,5.26-10.32,11.25-10.32s11.25,4.82,11.25,10.32c0,.55-.45,1-1,1Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_07-02_A-3"
      v-if="data.value === 'type-20' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="155.4" cy="196.35" r="2.65" :fill="data.color" />
          <circle cx="164.6" cy="196.35" r="2.65" :fill="data.color" />
          <path
            d="M172.17,199c-.69,0-1.25-.56-1.25-1.25,0-5.62-5.77-9.82-10.92-9.82-5.72,0-10.92,4.68-10.92,9.82,0,.69-.56,1.25-1.25,1.25s-1.25-.56-1.25-1.25c0-6.56,6.27-12.32,13.42-12.32s13.42,5.76,13.42,12.32c0,.69-.56,1.25-1.25,1.25Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <circle cx="155.4" cy="196.35" r="2.65" :fill="data.color" />
          <circle cx="164.6" cy="196.35" r="2.65" :fill="data.color" />
          <path
            d="M172.17,199c-.69,0-1.25-.56-1.25-1.25,0-5.62-5.77-9.82-10.92-9.82-5.72,0-10.92,4.68-10.92,9.82,0,.69-.56,1.25-1.25,1.25s-1.25-.56-1.25-1.25c0-6.56,6.27-12.32,13.42-12.32s13.42,5.76,13.42,12.32c0,.69-.56,1.25-1.25,1.25Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
    <g
      id="Nose_type_07-03_A-3"
      v-if="data.value === 'type-19' && data.position === 't'"
    >
      <g>
        <g>
          <circle cx="153.94" cy="196.13" r="3.64" :fill="data.color" />
          <circle cx="166.56" cy="196.13" r="3.64" :fill="data.color" />
          <path
            d="M175.83,199.77c-.83,0-1.5-.67-1.5-1.5,0-6.75-6.83-12.9-14.33-12.9s-14.33,6.15-14.33,12.9c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5c0-8.47,8.1-15.9,17.33-15.9s17.33,7.43,17.33,15.9c0,.83-.67,1.5-1.5,1.5Z"
            :fill="data.color"
          />
        </g>
        <g opacity=".3">
          <circle cx="153.94" cy="196.13" r="3.64" :fill="data.color" />
          <circle cx="166.56" cy="196.13" r="3.64" :fill="data.color" />
          <path
            d="M175.83,199.77c-.83,0-1.5-.67-1.5-1.5,0-6.75-6.83-12.9-14.33-12.9s-14.33,6.15-14.33,12.9c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5c0-8.47,8.1-15.9,17.33-15.9s17.33,7.43,17.33,15.9c0,.83-.67,1.5-1.5,1.5Z"
            :fill="data.color"
          />
        </g>
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarNoseC',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
